import { FcmTokenUpdated } from '@core/State/Device'
import { get } from '@classic/Foundation/Services/ApiService'
import { subscribeToNative, isReactNativeApp, sendToNative } from '@mobi/web-native-comms/web'
import { store } from '@core/Store'
import { registerNotifications } from '@core/Areas/Notifications/Store'
import { NotificationTime } from '@core/Areas/Notifications/types'

// Get FCM Token from native app then call API / registrations
// and get all notification registrations for that FCM Token
export function startRaceKeyNotification() {
  if (!isReactNativeApp) return
  const { dispose } = subscribeToNative(
    'RESPONSE_FCM_REGISTRATION_TOKEN_SUCCESS',
    (data: { token: string }) => {
      dispose()
      handleFCMToken(data)
    }
  )
  sendToNative('REQUEST_FCM_REGISTRATION_TOKEN')
}

function handleFCMToken(data: { token: string }) {
  const fcmToken = data.token

  FcmTokenUpdated({ fcmToken, fcmTokenStatus: 'Success' })

  get<string[]>({ url: `/api/notification/registrations?token=${fcmToken}` }).then(notifs => {
    // a notification is returned from api as '<id>|<comma sep time list>'
    store.dispatch(
      registerNotifications(
        notifs.map(x => {
          const [eventId, times] = x.split('|', 2)
          return {
            eventId,
            notificationTimes:
              times?.split(',').map(x => parseInt(x, 10) as NotificationTime) || [],
          }
        })
      )
    )
  })
}
